import React, { FC, useCallback } from 'react';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useController } from 'react-hook-form';

import DropzoneInput from '@buyside/components/presentation/Dropzone/DropzoneInput';

import styles from './attachmentFormStyles.scss';

const { ideaAttachmentFileTypes } = require('buyside/util/constantsFromRails.json');

const AttachmentDropzoneField: FC<{ isThesis: boolean }> = ({ isThesis }) => {
  const {
    field: { onChange: setFile }
  } = useController({ name: 'file' });

  const {
    field: { onChange: setFilename, value: filename },
    fieldState: { error }
  } = useController({ name: 'filename' });

  const {
    field: { onChange: setUrl }
  } = useController({ name: 'url' });

  const handleOnDrop = useCallback(
    ([file]: File[]) => {
      if (file) {
        setFile(file);
        setFilename(file.name);
        setUrl(URL.createObjectURL(file));
      }
    },
    [setFile, setFilename, setUrl]
  );

  let accept = ideaAttachmentFileTypes;
  if (isThesis) accept = [ideaAttachmentFileTypes['application/pdf']];

  return (
    <div>
      <DropzoneInput accept={accept} filename={filename} onDrop={handleOnDrop} />
      {error ? (
        <label className={styles.errorLabel}>
          <FontAwesomeIcon icon={faExclamationCircle} />
          {error.message}
        </label>
      ) : null}
    </div>
  );
};

export default AttachmentDropzoneField;
